import { STOP_TOOLTIP_CONFIG } from 'react/utils/stopUtils';

Greenmile.RouteDetail = Greenmile.RouteDetail || {};

Greenmile.RouteDetail.MarkerArrival = class {
  constructor(map, routeId) {
    const kind = 'ARRIVAL';
    this.removeArrivalsFromMap = () => {
      Greenmile.Map.Utility.removeLayerByKind(map, [kind]);
    };
    this.drawArrivals = (arrivals) => {
      const markers = [];
      const points = [];
      arrivals.models.forEach((item) => {
        const { id, arrivalLatitude, arrivalLongitude, plannedSequenceNum,
          actualSequenceNum, redeliveryStop, redeliveryType, totalRedelivery } = item.get('stop');
        if (arrivalLatitude && arrivalLongitude) {
          const marker = Greenmile.RouteDetail.Util.renderNumberedIconMarker({
            id,
            latitude: arrivalLatitude,
            longitude: arrivalLongitude,
            plannedSequenceNum,
            actualSequenceNum,
            redeliveryStop,
            kind
          });
          marker
            .bindTooltip(
              Monet.I18n.getResourcesByKey(
                'routeDetails.stopDetailsPopup.zones.arrivalLocation'
              ),
              STOP_TOOLTIP_CONFIG
            )
            .on('mouseover', () => marker.openTooltip())
            .on('mouseout', () => marker.closeTooltip());
          markers.push(marker);
          points.push([arrivalLatitude, arrivalLongitude]);
        }
      });
      markers.forEach((marker) => {
        map.addLayer(marker);
      });
      if (points.length > 1) {
        map.fitBounds(points);
      }
    };
    this.checkAndDrawArrivals = (collection) => {
      Monet.Session.RouteDetail.screensList[routeId].MarkerArrivals = collection;
      this.drawArrivals(collection);
    };
    this.getArrivalsAndDrawOnMap = () => {
      const success = (collection) => {
        this.removeArrivalsFromMap();
        this.checkAndDrawArrivals(collection);
      };
      App.Objects.RouteDetails.getStopDataToLayers(routeId, success);
    };
  }
};
